export class FetchError extends Error {
  public readonly status: number;

  public readonly info: any;

  constructor(message: string, status: number, info: any) {
    super(message);
    this.status = status;
    this.info = info;
  }
}
